import { create } from "zustand";
import { Languages } from "../enums/languages";

type DirectionType = 'ltr' | 'rtl';

interface IAppStore {
    useNewApi: boolean;
    language: Languages;
    langDirection: DirectionType;
    setLanguage: (language: Languages) => void;
    setUseNewApi: (useNewApi: boolean) => void;
}

export const useAppStore = create<IAppStore>()((set) => ({
    useNewApi: true,
    language: Languages.Hebrew,
    langDirection: 'rtl',
    setLanguage: (language: Languages) => set((state) => ({
        ...state,
        language,
        langDirection: language === Languages.English ? 'ltr' : 'rtl',
    })),
    setUseNewApi: (useNewApi: boolean) => set((state) => ({
        ...state,
        useNewApi,
    })),
}));

export const useGetUseNewApiApp = () => useAppStore((state) => state.useNewApi);
export const useGetLanguageApp = () => useAppStore((state) => state.language);
export const useGetLangDirectionApp = () => useAppStore((state) => state.langDirection);
export const useSetLanguageApp = () => useAppStore((state) => state.setLanguage);
export const useSetUseNewApiApp = () => useAppStore((state) => state.setUseNewApi);